import type { DesktopDisplayMode } from '../../types';
import type { ActualSearchProductCardProps } from './SearchProductCard';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getHeightHeuristic = (
  props: ActualSearchProductCardProps,
  displayMode: DesktopDisplayMode = 'moreInformation',
) => {
  let image = 0;
  if (props.product.variations[0].imageUrl?.includes('PL_landscape')) {
    image = 150;
  }
  if (props.product.variations[0].imageUrl?.includes('PL_square')) {
    image = 200;
  }
  if (props.product.variations[0].imageUrl?.includes('PL_portrait')) {
    image = displayMode === 'cards' ? 300 : 400;
  }

  const paddingAndMargin = 16;
  const brand = props.product.brand ? 18 : 0;
  // title is fairly hard to estimate, and varies a lot between display modes and device sizes
  // current numbers are mostly by trial and error
  const title = 24 + (props.product.title.length / (displayMode === 'cards' ? 25 : 40)) * 18;
  const price =
    28 +
    (props.product.variations[0].price.savingType ? 18 : 0) +
    (props.product.variations[0].pricePerUnit ? 14 : 0);

  const colors = 58;
  const rating = props.product.avgRating || props.useAdditionalFlagsSpacer ? 40 : 0;
  const additionalFlags = props.product.additionalFlags || props.useAdditionalFlagsSpacer ? 71 : 0;
  const additionalBulletPoints = props.product.additionalInfo
    ? 32 + props.product.additionalInfo.length * 48
    : 0;

  // image is mostly irrelevant because the bullet points dominate the height
  if (displayMode === 'moreInformation')
    return (
      paddingAndMargin + title + price + colors + rating + additionalFlags + additionalBulletPoints
    );

  return paddingAndMargin + image + brand + title + price + colors + rating + additionalFlags;
};
